module.exports = __webpack_public_path__ + "static/media/loader.aaa8f531.svg";